import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IMirrorFeature } from '../kb3d-models';
import { Token } from '../token';
import { ALL_GEOMETRY } from './feature';
import { SliceFeature } from './slice-feature';

@Kb3dModel({
    token: Token.MirrorFeature,
})
export class MirrorFeature extends SliceFeature implements IMirrorFeature {
    static _affectedBy = new Set(ALL_GEOMETRY);
    static _affects = new Set(ALL_GEOMETRY);

    cloneGeometry: boolean;
}
